import styled from 'styled-components'
import { Media, mbSize } from '../../theme'

export const Wrapper = styled.div<{ $fontSize: number; $fontSizeMb: number; $color: string }>`
  display: flex;
  align-items: center;
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  color: ${({ $color }) => $color};
  font-weight: 400;
  > svg {
    margin-right: 8px;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${({ $fontSizeMb }) => mbSize($fontSizeMb)};
    > svg {
      margin-right: ${mbSize(10)};
      width: ${mbSize(25)};
      height: ${mbSize(21)};
    }
  }
`
